import { AuthContext } from './AuthContext';
import { AuthProviderProps } from './types';
import useAuthState from './useAuthState';

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => (
  <AuthContext.Provider value={useAuthState()}>{children}</AuthContext.Provider>
);

export default AuthProvider;
